import { DialogController } from "aurelia-dialog";
import { inject } from "aurelia-framework";

@inject(DialogController)
export class Prompt {
    public controller: DialogController;
    public options: IPromptOptions = {
        title: "",
        message: "Do you want?",
        additionalMessage: "",
        okText: "Ok",
        cancelText: "Cancel"
    };

    public constructor(controller: DialogController) {
        this.controller = controller;
    }

    public activate(options: IPromptOptions) {
        Object.assign(this.options, options);
    }

    public cancel() {
        this.controller.cancel();
    }

    public saveDefault() {
        if (!!this.options.optionalText) {
            this.controller.ok(true); // Returns true if 3rd button is present
        } else {
            this.controller.ok(this.options); // Indicates default save
        }
    }

    public saveOptional() {
        this.controller.ok(false); // Indicates 3rd button pressed
    }
}

export interface IPromptOptions {
    title?: string;
    message: string;
    additionalMessage?: string;
    okText?: string;
    cancelText?: string;
    optionalText?: string;
    centerText?: boolean;
}
